import { QueryClient } from '@tanstack/react-query';

/**
 * Shared QueryClient instance for React Query (TanStack Query).
 *
 * This client is configured with default options that apply to all queries and mutations:
 * - Mutations: Retry is disabled to prevent duplicate operations
 * - Queries: Retry is disabled, and data is considered fresh for 5 minutes
 *
 * @example
 * ```tsx
 * import { queryClient } from '@/utils/query-client';
 * import { useQuery } from '@tanstack/react-query';
 *
 * function MyComponent() {
 *   const { data } = useQuery({
 *     queryKey: ['myData'],
 *     queryFn: fetchMyData,
 *     // Will use the default options from queryClient
 *   });
 * }
 * ```
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      retry: false,
    },
    queries: {
      retry: false, // Parity with Apollo client default
      staleTime: 5 * 60 * 1000, // Data is considered stale after 5 minutes
    },
  },
});
